import { useState } from 'react';
import { Outlet } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Header } from './Header';
import { Sidebar } from './Sidebar';
import { useRequireAuth } from '@/hooks/useAuth';
import { useProfileLanguageSync } from '@/hooks/useProfileLanguageSync';
import { SystemNotificationToasts } from '@/components/notifications/SystemNotificationToasts';

/**
 * Главный Layout для авторизованных страниц
 * @contract Обеспечивает единую структуру для всех защищённых роутов
 */
export function Layout() {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const { isAuthenticated, isLoading } = useRequireAuth();
  const { t } = useTranslation();

  // S4-35 (I1): язык интерфейса залогиненного берётся из профиля.
  useProfileLanguageSync(isAuthenticated && !isLoading);

  // Показываем загрузку пока проверяем auth
  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50 dark:bg-gray-900">
        <div className="flex flex-col items-center gap-4">
          <div className="w-12 h-12 rounded-full border-4 border-primary-200 border-t-primary-500 animate-spin" />
          <p className="text-gray-500 dark:text-gray-400">{t('common.loading')}</p>
        </div>
      </div>
    );
  }

  // Не рендерим пока не авторизованы (редирект произойдёт в useRequireAuth)
  if (!isAuthenticated) {
    return null;
  }

  return (
    <div className="flex h-screen bg-gray-50 dark:bg-gray-900">
      {/* Sidebar */}
      <Sidebar isOpen={sidebarOpen} onClose={() => setSidebarOpen(false)} />

      {/* Основной контент */}
      <div className="flex-1 flex flex-col overflow-hidden">
        {/* Header */}
        <Header onMenuClick={() => setSidebarOpen(true)} />

        {/* Page content */}
        <main className="flex-1 overflow-y-auto p-4 md:p-6">
          <Outlet />
        </main>
      </div>

      {/* SysNot-1: real-time deterministic events (reminders, memory, routing).
         Mounted at Layout level so toasts persist across route changes. */}
      <SystemNotificationToasts />
    </div>
  );
}
